export function createMixin(client, target) {
  return function RuntimeOperationMixin(Resource) {
    return class extends Resource {
      get target() {
        return target;
      }

      invoke(body, headers) {
        if (body !== null && typeof body !== 'undefined') {
          return client.invokeOperation(this, headers, body);
        }

        return client.invokeOperation(this);
      }

    };
  };
}